module.exports = __webpack_public_path__ + "img/低碳建築聯盟結業證明.5d6f6ef8.jpg";